import {
  AVISO_VALORES_PROVISORIOS,
  ENSAIO_REFERENCIA,
  ensaioDeTodosOsMateriais,
  MATERIAIS_TALABARTE,
  parametrosDoObjeto,
  redutorEfetivo,
  type ObjetoTabletop,
} from '../../dominio/tabletop'

const virgula = (valor: number, casas = 1) => valor.toFixed(casas).replace('.', ',')

/**
 * O ensaio de referência: a mesma massa, a mesma queda e o mesmo comprimento de
 * corda para cada material, com o redutor de força do trabalhador, contra o
 * critério de pico. É uma régua para comparar os sistemas, e não vale como
 * ensaio de equipamento: os números e o critério são provisórios.
 */
export function EnsaioDeReferencia({ objeto }: { objeto: ObjetoTabletop }) {
  const p = parametrosDoObjeto(objeto)
  const redutor = redutorEfetivo(p)
  const linhas = ensaioDeTodosOsMateriais(redutor.tipo, { absorvedor: { forcaKN: p.forcaAbsorvedorKN!, aberturaM: p.absorvedorAberturaM! } })
  return (
    <details className="ensaio-referencia">
      <summary>
        Ensaio de referência: {ENSAIO_REFERENCIA.massaKg} kg caindo {virgula(ENSAIO_REFERENCIA.quedaLivreM, 0)} m em{' '}
        {virgula(ENSAIO_REFERENCIA.comprimentoCordaM, 0)} m de corda
      </summary>
      <p className="dica">
        Com {redutor.nome}. O critério é de {virgula(ENSAIO_REFERENCIA.valor, 0)} kN de pico no corpo.
      </p>
      <table className="ensaio-referencia__tabela">
        <thead>
          <tr>
            <th scope="col">Material</th>
            <th scope="col">Pico</th>
            <th scope="col">Desce</th>
            <th scope="col">Critério</th>
          </tr>
        </thead>
        <tbody>
          {linhas.map((l) => (
            <tr key={l.material}>
              <th scope="row">{MATERIAIS_TALABARTE[l.material].nome}</th>
              <td>{virgula(l.resultado.forcaPicoKN)} kN</td>
              <td>{virgula(l.distanciaDeParadaM, 2)} m</td>
              <td className={l.passa ? 'ensaio-referencia__passa' : undefined}>
                {l.passa ? 'passa' : 'não passa'}
                {l.resultado.regime === 'absorvedor-esgotado' && ' · redutor esgotou'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="dica">
        {AVISO_VALORES_PROVISORIOS} Os números do ensaio (massa, altura, comprimento e critério) também são provisórios.
      </p>
    </details>
  )
}
